/**
 * Dark mode is disabled store-wide (client request, 2026-07-28).
 *
 * The site always renders light. This file used to bind [data-theme-toggle]
 * and follow the OS color-scheme; it now only enforces the light theme and
 * clears any previously stored dark preference so returning visitors un-dark.
 * The file is kept (rather than deleted) because layout/theme.liquid still
 * references the asset.
 */
(function () {
  try { localStorage.removeItem('nerdio-theme'); } catch (_) {}
  document.documentElement.dataset.theme = 'light';
})();
